/** The `$accountId` path param reaches the page as `router.query.accountId`. */
import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingAccountTransactions } from '@/features/accounting/pages/account-transactions'
import Head from '@/lib/navigation/head'

function AccountTransactionsRoute() {
  return (
    <>
      <Head>
        <title>Account transactions | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Account transactions" sticky />}>
        <AccountingAccountTransactions />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/accounts/$accountId')({
  component: AccountTransactionsRoute,
})
